import React from 'react';
import logo from "../logo/ABK.png";
import { BorderBottom, BorderLeft, BorderRight, BorderTop } from '@material-ui/icons';
//import QRCode from 'qrcode.react';
import BankQRCode from "../logo/BankQRCode/Taj paradise.png";
import AliKunjuQrCode from "../logo/AliKunjuQrCode/Screenshot 2024-08-31 114102.png";
//import ThayyibQRcode from "../logo/ThayyibQRcode/Screenshot 2024-08-31 114207.png";
import ThayyibQRcode from "../logo/ThayyibQRcode/New_QR.jpeg";
import signseal from "../logo/signseal/ABK_Sign n.jpg";

const BillPrint = ({ onClose, labelData }) => {


    const containerStyleN = {
        border: 'none',
        padding: '10px',
        width: '94%',
        marginTop: '10px', // Adjust the top margin as needed
        marginLeft: '10px',
        marginRight: '0px',
    };

    const containerStyle = {
        border: '1px solid #000',
        padding: '5px',
        width: '100%',
        marginTop: '5px', // Adjust the top margin as needed
        marginLeft: '0px',
        marginRight: '5px',
    };

    const tableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        textAlign: 'center',
    };

    const cellStyle = {
        border: '1px solid #000',
        padding: '0px',
    };

    const cellStyleN = {
        border: 'none',
        padding: '0px',
    };

    const cellStyleN1 = {
        borderBottom: '1px solid black',
        borderTop: 'none',
        borderLeft: 'none',
        borderRight: 'none',
    };


    const cellStyleP = {
        BorderBottom: 'none',
        BorderTop: 'none',
        borderLeft: '1px solid black',
        borderRight: '1px solid black',
        padding: '0px',
    };

    const cellStyleP1 = {
        borderBottom: '1px solid black',
        BorderTop: 'none',
        borderLeft: '1px solid black',
        borderRight: '1px solid black',
        padding: '0px',
    };

    const cellStyleL = {
        BorderBottom: 'none',
        BorderTop: 'none',
        borderLeft: '1px solid black',
        borderRight: 'none',
        padding: '0px',
    };

    const cellStyleL1 = {
        borderBottom: '1px solid black',
        BorderTop: 'none',
        borderLeft: '1px solid black',
        borderRight: 'none',
        padding: '0px',
    };

    const headerStyle = {
        color: 'blue',
        fontStyle: 'italic',
        fontFamily: 'Newtown, sans-serif',
        textAlign: 'center',
    };

    const labelStyle = {
        marginTop: '5px',
        fontFamily: 'Arial',
        fontSize: '12px',
        marginRight: '5px',
    };

    const NumberToWords = (num) => {
        const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const teens = ['Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

        const convert = (num) => {
            if (num < 10) return units[num];
            if (num < 20) return teens[num - 11];
            if (num < 100) return tens[Math.floor(num / 10)] + ' ' + units[num % 10];
            if (num < 1000) return units[Math.floor(num / 100)] + ' Hundred ' + convert(num % 100).trim();
            if (num < 100000) return (convert(Math.floor(num / 1000)) + ' Thousand ' + convert(num % 1000)).trim();
            if (num < 1000000) return (convert(Math.floor(num / 100000)) + ' Lakh ' + convert(num % 100000)).trim();
            return 'Number is too large';
        };

        if (num === 0) return 'Zero';
        return convert(num);
    };

    const AmountInWords = ({ amount }) => {
        const formattedAmount = parseFloat(amount).toFixed(2);
        const [rupees, decimal] = formattedAmount.split('.');

        return (
            <div>
                <h5>Rupees {NumberToWords(parseInt(rupees))} Only</h5>
                {decimal !== "00" && <p>{NumberToWords(parseInt(decimal))} Paise Only</p>}
            </div>
        );
    };

    {/* <img src={logo} alt="Company Logo" style={{ maxHeight: '80px', margin: '0 auto' }} /> */ }
    {/* <QRCode value={labelData.paymentqr} size={110} style={{ marginLeft: 'auto' }} /> */ }

    return (

        <div style={containerStyleN}>
            {/* Render your label content using the fetched data */}
            {labelData && (
                <div>

                    <div style={{ textAlign: 'center', marginBottom: '0px' }}>
                        <img src={logo} alt="Company Logo" style={{ maxHeight: '80px', margin: '0 auto' }} />
                        {String(labelData.bankId) === '1' && (
                            <img src={ThayyibQRcode} alt="QR Code" style={{ position: 'absolute', top: '35px', right: '25px', maxWidth: '110px', maxHeight: '110px' }} />
                        )}
                        {String(labelData.bankId) === '2' && (
                            <img src={AliKunjuQrCode} alt="QR Code" style={{ position: 'absolute', top: '35px', right: '25px', maxWidth: '110px', maxHeight: '110px' }} />
                        )}
                        {String(labelData.bankId) === '3' && (
                            <img src={BankQRCode} alt="QR Code" style={{ position: 'absolute', top: '35px', right: '25px', maxWidth: '110px', maxHeight: '110px' }} />
                        )}
                    </div>


                    <h4 style={{ textAlign: 'center', marginBottom: '0px', marginTop: '0px' }}>
                        {labelData.companyName}
                    </h4>
                    <h5 style={{ textAlign: 'center', marginTop: '0', marginBottom: '0px' }}>
                        {labelData.address}
                    </h5>
                    <h5 style={{ textAlign: 'center', marginTop: '0', marginBottom: '0px' }}>
                        Phone No: {labelData.companyContactNumber}
                    </h5>
                </div>
            )}


            {labelData && (
                <table style={{ ...tableStyle, marginTop: '10px' }}>

                    <tr>
                        <td style={{ ...cellStyleN, width: '30%', textAlign: 'left' }}>
                            <h4 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '10px' }}> Invoice Number: {labelData.billNO}</h4>
                        </td>
                        <td style={{ ...cellStyleN, width: '40%', textAlign: 'center', marginTop: '0', marginBottom: '0' }}>
                            <h4 style={{ textAlign: 'center', marginTop: '1px', marginBottom: '0px' }}>RENT INVOICE</h4>
                        </td>
                        <td style={{ ...cellStyleN, width: '30%', textAlign: 'left', marginTop: '0', marginBottom: '0' }}>
                            <h4 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '50px' }} >Invoice Date: {labelData.billDate ? new Date(labelData.billDate).toLocaleDateString('en-GB', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric'
                            }) : 'N/A'}</h4>
                        </td>
                    </tr>
                </table>
            )}

            {labelData && (
                <table style={{ ...tableStyle, marginTop: '20px' }}>

                    <tr>
                        <td style={{ ...cellStyle, width: '100%', textAlign: 'left', marginTop: '20px' }}>
                            <h5 style={{ textAlign: 'left', marginTop: '10px', marginBottom: '0px', marginLeft: '10px', marginRight: '10px' }}>Customer Name & Address</h5>
                            <h5 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '10px', marginRight: '10px' }}>{labelData.name}</h5>
                            {labelData.addressLine1 ? (
                                <h5 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '10px', marginRight: '10px' }}>{labelData.addressLine1}</h5>
                            ) : (
                                <h5 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '10px', marginRight: '10px', visibility: 'hidden' }}>Customer Address: Not Available</h5>
                            )}
                            <h5 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '10px', marginRight: '10px' }}>{labelData.phoneNumber}</h5>

                        </td>
                    </tr>



                </table>
            )}

            {labelData && (
                <table style={tableStyle}>
                    <thead>
                        <tr>
                            <td style={{ ...cellStyle, width: '15%' }}>
                                <h5 style={{ marginTop: '4px', marginBottom: '2px' }}>Rent Date</h5>
                            </td>
                            <td style={{ ...cellStyle, width: '70%' }}>
                                <h5 style={{ marginTop: '5px', marginBottom: '2px', textAlign: 'left', marginLeft: '15px' }}>Room</h5>
                            </td>
                            <td style={{ ...cellStyle, width: '15%' }}>
                                <h5 style={{ marginTop: '5px', marginBottom: '2px' }}>Amount</h5>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        {labelData && (
                            <tr style={{ height: '40px' }}>
                                <td style={{ ...cellStyleP, width: '15%', height: '20px', textAlign: 'left', borderBottom: '1px solid black' }}>
                                    <h4 style={{ textAlign: 'left', marginTop: '0', marginBottom: '1px', marginLeft: '10px', marginRight: '10px' }}>
                                        <label style={labelStyle}>
                                            {labelData.billDate ? new Date(labelData.billDate).toLocaleDateString('en-GB', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric'
                                            }) : 'N/A'}
                                        </label>
                                    </h4>
                                </td>
                                <td style={{ ...cellStyleP, width: '70%', height: '20px', textAlign: 'left', borderBottom: '1px solid black' }}>

                                    <h4 style={{ textAlign: 'left', marginTop: '0', marginBottom: '1px', marginLeft: '10px', marginRight: '10px' }}>
                                        <div style={{ marginLeft: '5px' }}>
                                            <label style={{
                                                marginTop: '5px',
                                                fontFamily: 'Arial',
                                                fontSize: '12px',
                                                textAlign: 'left',
                                                wordWrap: 'break-word',
                                                whiteSpace: 'normal'
                                            }}>
                                                {labelData.room}
                                            </label>
                                        </div>
                                    </h4>
                                </td>
                                <td style={{ ...cellStyleP, width: '15%', height: '20px', textAlign: 'right', borderBottom: '1px solid black' }}>
                                    <h4 style={{ textAlign: 'right', marginTop: '0', marginBottom: '1px', marginLeft: '10px', marginRight: '10px' }}>
                                        {labelData.billAmount}
                                    </h4>
                                </td>
                            </tr>
                        )}

                    </tbody>
                </table>
            )}


            <div>
                <table style={tableStyle}>
                    <tbody>
                        <tr style={{ height: '10px' }}>
                            <td style={{ ...cellStyle, width: '70%', textAlign: 'left' }}>
                                <h4 style={{ marginTop: '2px', marginLeft: '10px', marginBottom: '2px' }}>
                                    <AmountInWords amount={labelData.billAmount} />
                                </h4>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>


            {/* <div style={{ textAlign: 'center', marginBottom: '0px', marginLeft: '-100%' }}>
                <img src={signseal} alt="QR Code" style={{ marginTop: '3px', marginLeft: '-100%', position: 'absolute', right: '0', maxWidth: '110px', maxHeight: '110px' }} />
            </div> */}
            <div style={{ textAlign: 'center', marginBottom: '0px', marginLeft: '92%' }}>
                <img src={signseal} alt="QR Code" style={{ marginTop: '3px', position: 'relative', maxWidth: '110px', maxHeight: '110px', transform: 'translateX(-50%)' }} />
            </div>


            <div style={{ ...containerStyleN, marginTop: '-5px' }}>

                <h5 style={{ textAlign: 'left', marginBottom: '10px', color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', fontSize: 'smaller' }}>
                    Rental Receipt Terms and Conditions
                </h5>
                <p style={{ textAlign: 'left', marginBottom: '5px', color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', fontSize: 'smaller' }}>
                    1. Payment: Rent is payable in advance on or before the tenant&#39;s respective renewal date of every
                    month. Payments can be made via bank transfer or cash. Booking amount or Rent paid is non refundable
                    at any circumstances. Once paid, it's considered final and cannot be returned.
                </p>
                <p style={{ textAlign: 'left', marginBottom: '5px', color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', fontSize: 'smaller' }}>
                    2. Late Fees: A late fee of 2% of the monthly rent will be applied if the rent is not received within five (5)
                    days of the due date.
                </p>
                <p style={{ textAlign: 'left', marginBottom: '5px', color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', fontSize: 'smaller' }}>
                    3. Security Deposit: The security deposit is held against any damages to the property or unpaid rent. It is
                    refundable at the end of the tenancy, subject to the condition of the property and any outstanding dues.
                    Note: a deduction from the caution fee will be made for cleaning charges at the time of vacating the
                    room.
                </p>
                <p style={{ textAlign: 'left', marginBottom: '5px', color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', fontSize: 'smaller' }}>
                    4. Maintenance and Repairs: Tenants must promptly report any maintenance or repair needs. Routine
                    maintenance is covered by the landlord, but tenants are responsible for the cost of repairs caused by
                    their negligence or misuse.
                </p>
                <p style={{ textAlign: 'left', marginBottom: '5px', color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', fontSize: 'smaller' }}>
                    5. Property Use: The property is to be used exclusively for residential purposes and cannot be sublet or
                    used for any commercial activities.
                </p>
                <p style={{ textAlign: 'left', marginBottom: '5px', color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', fontSize: 'smaller' }}>
                    6. Termination: A minimum of 15 days&#39; written notice is required from either party to terminate the
                    lease agreement. Early termination by the tenant may result in forfeiture of the security deposit.
                </p>
                <p style={{ textAlign: 'left', marginBottom: '5px', color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', fontSize: 'smaller' }}>
                    7. Conduct: Tenants are expected to maintain a peaceful environment and avoid causing any
                    disturbances to neighbors. Any illegal activities on the premises will lead to immediate eviction.
                </p>
                <p style={{ textAlign: 'left', marginBottom: '5px', color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', fontSize: 'smaller' }}>
                    8. Alterations: Tenants are not allowed to make any alterations, additions, or improvements to the
                    property.
                </p>
                <p style={{ textAlign: 'left', marginBottom: '5px', color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', fontSize: 'smaller' }}>
                    9. Entry: The landlord reserves the right to enter the property for inspections, repairs, or showings, with
                    reasonable notice to the tenant, except in emergencies.
                </p>

                <p style={{ textAlign: 'left', marginBottom: '5px', color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', fontSize: 'smaller' }}>
                    10. Compliance: Tenants must comply with all local, state, and federal laws and regulations.
                </p>
                <p style={{ textAlign: 'left', marginBottom: '5px', color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', fontSize: 'smaller' }}>
                    11. Default: Failure to comply with any terms and conditions may result in termination of the lease and
                    eviction from the property.
                </p>

            </div>

            {/* <div style={{ textAlign: 'center', marginBottom: '0px' }}>

                {labelData.bankId == 1 && (

                    <img src={ThayyibQRcode} alt="QR Code" style={{ position: 'absolute', maxWidth: '110px', maxHeight: '110px' }} />
                )}
                {labelData.bankId == 2 && (

                    <img src={AliKunjuQrCode} alt="QR Code" style={{ position: 'absolute', maxWidth: '110px', maxHeight: '110px' }} />
                )}
                {labelData.bankId == 3 && (

                    <img src={BankQRCode} alt="QR Code" style={{ position: 'absolute', maxWidth: '110px', maxHeight: '110px' }} />
                )}
            </div> */}
            <style>
                {`
                    @media print {
                        @page {
                            margin: 0;
                        }
                        body {
                            margin: 1px;
                        }
                    }
                `}
            </style>

        </div >
    );
};

export default BillPrint;
